import React,{Component} from 'react'
import '../styles/style.css'
import * as constantURL from '../common/constants'
import axios from 'axios'
import {FRONT_END_NAME} from '../common/constants'
import $ from 'jquery'
import Loader from '../common/loader'
import Popup from '../component/popup'
class Login extends Component{

    constructor(props){
        super(props);
        this.state = {
            showLoader : false,
            accessToken : "",
            showOtp :false,
            timeToResend : 45,
            countTimer : 45,
            showPopup : false,
            popupMsg : "Msg",
            popupHeader : "Header",
            popupFunction : this.togglePopup
        }

        this.loginViaHeader();
        this.timer = 0;
    }

    componentDidMount(){
        $("#mobileNo").on("keyup keypress blur",function (event) {  
    		$(this).val($(this).val().replace(/[^0-9]/gi, ''));
        });

        $("#mobileNo").on("keyup keypress blur",function (event) {  
            
            if($.trim($(this).val()).length > 9){
                $(this).val($(this).val().substring(0,9))
            }
            if($.trim($(this).val()).length < 9){
                
                $("#next").removeClass("temp-activate");
                $("#next").addClass("temp-deactivate");
                $("#next").prop("disabled", true);
                
            }
            else{
                
                $("#next").addClass("temp-activate");
                $("#next").removeClass("temp-deactivate");
                $("#next").prop("disabled", false);
            }
      });

      
        $("#1, #2, #3, #4, #5, #6").on("keyup change keypress blur",function (event) { 
           //if($(this).val())
           if(event.key==='.'){event.preventDefault();}
            //$(this).val( $(this).val()+"7") ;
            console.log("value is now",$(this).val());
                $(this).val($(this).val().replace(/[^0-9]/gi, ''));
                if(this.value.length>1){
                    this.value = this.value.slice(0,1); 
                }
            var elem = this;
                setTimeout(function(){
                var key = event.keyCode || event.charCode;
                var isBackspace = (key==8 || key==46);
                if(isBackspace){
                    if(elem.id == '1'){
                       
                         
                    }
                    else{
                        $("#"+(parseInt(elem.id)-1)).focus();
                    }
                    return false;
                }

                
                if($(elem).val() != ""){
                    if(elem.id == '6'){
                        $("#verifyOtp").focus();
                        
                        var otp= $(".form-otp").map(function() {
                            return $(this).val();
                         }).get();
                         //this.state.otp = otp;
                         
                    }
                    else{
                        $("#"+(parseInt(elem.id)+1)).focus();
                    }
                }
                var enableButton = true;
                
                $(".form-otp").each(function(index, value) {
                    if($(value).val() == ""){
                        enableButton = false;
                    }
                });
                
                if(!enableButton){
                    $("#verifyOtp").removeClass("temp-activate");
                    $("#verifyOtp").addClass("temp-deactivate");
                    $("#verifyOtp").prop("disabled", true);
                    
                }
                else{
                    $("#verifyOtp").addClass("temp-activate");
                    $("#verifyOtp").removeClass("temp-deactivate");
                    $("#verifyOtp").prop("disabled", false);
                    
                }
                },100);
                
        });


    }
   
    loginViaHeader = () =>{
        this.setState({showLoader:true});
        

        var url = constantURL.Profiler_ENGINE_IP_ADDRESS + "/v1/loginbypass";
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'deviceId': constantURL.DEVICE_ID,
            'channel': constantURL.CHANNEL,
            'operator': constantURL.OPERATOR,
            'access_token': '',
            'appid': constantURL.APP_ID,
            //'msisdn':msisdn //temp according to logic
        };

        axios.get(url, { headers })
        .then(response => response.data)
            .then((data) => {
              //  debugger;
                console.log("data in login skip api ", data);
                if(data && data.code == 4000){
                    this.setState({showLoader:false});
                }
                else if (data && data.code == 2000) {

                    console.log(data)
                    try{
                    
                            var userData = {
                                username:data.data.username,
                                countryCode : constantURL.COUNTRY_CODE
                    
                            };
                            constantURL.setObjectInSS("userdata",constantURL.convertObjectBeforeSaving({"phone":userData}));

                            var userData = constantURL.parseObjectBeforeGet("userdata");//JSON.parse(localStorage["userdata"]);
                            //var phone = userData.phone;
                            this.setState({phoneData:userData});

                            
                            constantURL.setObjectInSS("userdata",constantURL.convertObjectBeforeSaving({"phone":userData}));
                            userData.profilerData = data.data;
                            userData.profilerData.user = {
                                username : userData.profilerData.username,
                                accessToken : userData.profilerData.accessToken
                            }
                            constantURL.setObjectInSS("userdata",constantURL.convertObjectBeforeSaving(userData));
                            this.setState({accessToken : data.data.user.accessToken});
                            
                            this.props.history.push(FRONT_END_NAME+"/home");
                        }
                        catch(error)
                        {
                            alert('some error occured in receving data in login skip');
                        }

                } else {
                    
                    alert("user login unsuccessfull !");
                }
            })
            .catch(error=>{
                console.log();
                console.error('error',error);
                alert('Network Error In Login')
            });
    }

    togglePopup = () => {
		this.setState({
			showPopup: !this.state.showPopup
		});
	}

    sendOTP = ()=>{
       
        this.setState({showLoader:true});
        var headers = constantURL.getCommonHeaders();
        // headers.msisdn = this.props.msisdn;
        var username = document.getElementById("mobileNo").value;
        delete headers.access_token;
        delete headers.msisdn;
       
        console.log("headers, ",headers);
        var data = {
            username:username,
            countryCode : constantURL.COUNTRY_CODE

        };
        constantURL.setObjectInSS("userdata",constantURL.convertObjectBeforeSaving({"phone":data}));
        this.setState({phoneData:data});
        axios.post(constantURL.Profiler_ENGINE_IP_ADDRESS+"/v2/submitLoginOrSignUp?buildstamp="+(new Date().getTime()),
        data,
        {
            headers: headers
        }
        ).then(response=>{
            if(response.data.code == 2000){
            $("#resendOtp").addClass("temp-deactivate");
            setTimeout(function(){
                $("#resendOtp").removeClass("temp-deactivate");
            },this.state.timeToResend*1000);

            if(this.timer !=0 ){
                clearTimeout(this.timer);
            }
            this.setState({countTimer:this.state.timeToResend},()=>{
                this.timer  = setInterval(()=>{
                    this.setState({countTimer:this.state.countTimer-1},()=>{
                        if(this.state.countTimer == 0){
                            clearTimeout(this.timer);
                        }
                    });
                },1000)
            })



            this.setState({showLoader:false,showOtp:true});
            console.log("response outside",response);
            
                console.log("response",response);
                // this.props.history.push(FRONT_END_NAME+"/otp");
                $("#1").focus();
            }
            else{
                this.showPopup("Max OTP Attempts !","You have done too many attempts. Please try after some time.",true);
            }
        });

    }

    validateOTP = ()=>{
        if(!sessionStorage["otpAttempt"] || isNaN(sessionStorage["otpAttempt"])){
            sessionStorage["otpAttempt"] = 0;
        }
        if(parseInt(sessionStorage["otpAttempt"]) >= 5){
            this.showPopup("Verification Status: Fail","You have done too many attempts. Please try after some time.",true);
            return;
        }
        this.setState({showLoader:true});
        var headers = constantURL.getCommonHeaders();
       // headers.msisdn = this.props.msisdn;
        delete headers.operator;
        delete headers.channel;
        delete headers.access_token;
        delete headers.msisdn;
        delete headers.deviceId;
        //delete headers['Content-Type'];
        console.log("headers, ",headers);

        var data = this.state.phoneData;
        var otp =  $(".form-otp").map(function() {
            return $(this).val();
         }).get();
        data.otp = otp.join('');
        console.log("data",data);
        //console.log("url",constantURL.Profiler_ENGINE_IP_ADDRESS+"/v1/validateOtpAndLogin&buildstamp="+(new Date().getTime()));
        axios.post(constantURL.Profiler_ENGINE_IP_ADDRESS+"/v1/validateOtpAndLogin",
        data,
        {
            headers: headers
        }
        ).then(response=>{
           
            console.log("response",response);
            if(response.data.code == 2000){
                //this.props.history.push("/tambola/otp");
                var userData = constantURL.parseObjectBeforeGet("userdata");
                userData.profilerData = response.data.data;
                constantURL.setObjectInSS("userdata",constantURL.convertObjectBeforeSaving(userData));
                this.setState({accessToken : response.data.data.user.accessToken});
                console.log("response.data.data.accessToken",response.data.data.user.accessToken);
                //this.getUserDetails();
                this.showPopup("Success","You have successfully verified yourself. Enjoy the Service",false);
                this.props.history.push(FRONT_END_NAME+"/home");
            }
           
            else{
                //alert("Invalid OTP, Please enter OTP again");
                this.showPopup("Verification Status : Fail","Entered OTP is wrong, re-enter the OTP",true);
                if(!sessionStorage["otpAttempt"] || isNaN(sessionStorage["otpAttempt"])){
                    sessionStorage["otpAttempt"] = 0;
                }
                else{
                    sessionStorage["otpAttempt"] = parseInt(sessionStorage["otpAttempt"])+1;
                }
                $(".otp-info").hide();
                $("#otp-info-1").show();
                $("#1").focus();
                $(".form-otp").val("");
                this.setState({showLoader:false});
            }
        });

    }

    showPopup = (header,msg,error) =>{
        this.setState({
            popupHeader:header,
            popupMsg:msg,
            isErrorPopup:error,
            showPopup:true
        })
    }

    render(){
        return(
            <div className="container-login">
                {this.state.showLoader && <Loader></Loader>}
                {this.state.showPopup && <Popup
                    heading = {this.state.popupHeader}
                    msg = {this.state.popupMsg}
                    onClick={this.togglePopup}
                    error={this.state.isErrorPopup}
                ></Popup>}
                <div id="loginDiv" >
                    <p className="login-text">Login</p>
                    <p className="identify">We are not able to identify you</p>
                    <p className="enter">Enter Your Number</p>
                    <input className="login-input" readOnly={this.state.showOtp} id="mobileNo" type="number" placeholder="Enter No"></input>
                    <div><button  type="button" className="proceed-btn next temp-deactivate" id="next" onClick={()=>this.sendOTP()} style={{display:this.state.showOtp?"none":"block"}}>Proceed</button></div>
                    <p className="note" style={{display:this.state.showOtp?"none":"block"}}>Please Note : This service is for MTN customers only</p>
                </div>
                
                <div className="otp-div" style={{display:this.state.showOtp?"block":"none"}}>
                    <p className="cover">
                        <span className="e-otp">Enter OTP</span>
                        <span className="e-time">00:{this.state.countTimer}</span>
                    </p>
                    <div className="otp-input">
                        <input type="number" id="1" className="form-otp" maxLength="1"  />
                        <span></span>
                        <input type="number" id="2" className="form-otp input-otp-extra" maxLength="1" />
                        <span></span>
                        <input type="number" id="3" className="form-otp input-otp-extra" maxLength="1" />
                        <span></span>
                        <input type="number" id="4" className="form-otp input-otp-extra" maxLength="1" />
                        <span></span>
                        <input type="number" id="5" className="form-otp input-otp-extra" maxLength="1" />
                        <span></span>
                        <input type="number" id="6" className="form-otp input-otp-extra" maxLength="1" />
                    </div>
                    <p className="resend-otp temp-deactivate" id="resendOtp" onClick={()=>this.sendOTP()}>Resend OTP</p>
                    <div className="verify-div "><button className="temp-deactivate" type="button" onClick={this.validateOTP} id="verifyOtp">Verify</button></div>
                </div>
            </div>
        )
    }
}

export default Login